import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { updateNewsletter as updateNewsletterAction } from '../../actions/user.actions';
import EmptyCheckbox from '../../assets/lernsets/icons/checkbox.svg';
import SelectedCheckbox from '../../assets/lernsets/icons/selectedCheckbox.svg';
import { palette, spaces } from '../../assets/styles/themes/tokens';
import useAction from '../../utils/useAction';

interface SubscriptionNewsLetterProps {
	initialValue?: boolean;
}

const SubscriptionNewsLetter: React.FC<SubscriptionNewsLetterProps> = ({
	initialValue = false,
}) => {
	const { t } = useTranslation();
	const updateNewsletter = useAction(updateNewsletterAction);
	const [isChecked, setIsChecked] = useState(initialValue);
	const [isLoading, setIsLoading] = useState(false);

	const handleToggle = useCallback(async () => {
		const newValue = !isChecked;
		setIsChecked(newValue);
		setIsLoading(true);

		try {
			await updateNewsletter(newValue);
		} catch {
			setIsChecked(!newValue);
		} finally {
			setIsLoading(false);
		}
	}, [isChecked, updateNewsletter]);

	return (
		<Box
			data-testid="subscription-newsletter"
			sx={{
				display: 'flex',
				flexDirection: 'column',
				gap: spaces.md,
			}}
		>
			<Typography color={palette.text.secondary} variant="body1">
				{t('With our weekly to bi-weekly newsletter...')}
			</Typography>

			<FormControlLabel
				sx={{
					pl: 0,
					ml: 0,
					alignItems: 'flex-start',
					'& .MuiFormControlLabel-label': {
						color: palette.text.primary,
					},
				}}
				control={
					<Checkbox
						name="isSubscribedToNewsletter"
						color="primary"
						size="small"
						icon={<EmptyCheckbox />}
						checkedIcon={<SelectedCheckbox />}
						checked={isChecked}
						onChange={handleToggle}
						disabled={isLoading}
						sx={{
							p: 0,
							mr: spaces.xs,
							alignSelf: 'flex-start',
						}}
					/>
				}
				labelPlacement="end"
				label={
					<Typography variant="body1" color={palette.text.primary}>
						{t("I'd like to receive the newsletter")}
					</Typography>
				}
			/>
		</Box>
	);
};

export default SubscriptionNewsLetter;
